import { createAsyncThunk } from "@reduxjs/toolkit";

import axios from "../../../axios";

export const getMyCoachReview = createAsyncThunk(
  "review/getMyCoachReview",
  async (params = {}, { rejectWithValue }) => {
    const { coachId } = params;

    try {
      const response = await axios.get("/reviews/my", {
        params: { coachId },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch review status",
      });
    }
  },
);

export const submitReview = createAsyncThunk(
  "review/submitReview",
  async (params = {}, { rejectWithValue }) => {
    const { coachId, rating, review } = params;

    try {
      const response = await axios.post("/reviews", {
        coachId,
        rating,
        review,
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to submit review",
      });
    }
  },
);

export const updateReview = createAsyncThunk(
  "review/updateReview",
  async (params = {}, { rejectWithValue }) => {
    const { coachId, rating, review } = params;

    try {
      const response = await axios.put("/reviews", {
        coachId,
        rating,
        review,
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to update review",
      });
    }
  },
);

export const getCoachReviews = createAsyncThunk(
  "review/getCoachReviews",
  async (params = {}, { rejectWithValue }) => {
    const { coachId, limit = 10, skip = 0 } = params;

    try {
      const response = await axios.get(`/reviews/coach/${coachId}`, {
        params: { limit, skip },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch reviews",
      });
    }
  },
);
